import MaterialListItemButton, {
    ListItemButtonProps,
} from '@mui/material/ListItemButton';

export function ListItemButton(props: ListItemButtonProps) {
    return (
        <MaterialListItemButton
            data-testid={'ListItemButton-container'}
            {...props}
        ></MaterialListItemButton>
    );
}

export default ListItemButton;
